import { render, staticRenderFns } from "./ModalCadastrarUsuario.vue?vue&type=template&id=20a41e7c"
import script from "./ModalCadastrarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports